import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { LocalStorage } from 'ngx-store';

@Injectable({
  providedIn: 'root'
})
export class TargetDetectionService {
  api: string = environment.apiUrl;
  @LocalStorage('loggedUser') loggedUser: any;
  @LocalStorage('userData') userData: any;
  lan = localStorage.getItem("lan")

  constructor(private http: HttpClient) { }

  async save(body): Promise<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json', Authorization: 'Bearer ' + this.loggedUser.access_token });
    return await this.http
      .post(this.api + `/posner/posner_test`, { answers: body }, { headers, observe: 'response' })
      .toPromise();
  }

  async save_wrong(body): Promise<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json', Authorization: 'Bearer ' + this.loggedUser.access_token });
    return await this.http
      .post(this.api + `/posner/posner_test_wrong`, { answers: body }, { headers, observe: 'response' })
      .toPromise();
  }

  async check_exp(): Promise<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json', Authorization: 'Bearer ' + this.loggedUser.access_token });
    return await this.http
      .get(this.api + `/checkPosner`, { headers, observe: 'response' }).toPromise();
  }

  async get_trials(): Promise<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json', Authorization: 'Bearer ' + this.loggedUser.access_token });
    return await this.http
      .get(this.api + `/posner/posner_test` + `?language=` + this.lan, { headers, observe: 'response', }).toPromise();
  }


}
